import mergeDeep from '@/utils/merge-deep';
import { ListCardsThemeControls } from '@/components/molecules/ListCards/theming';

import block from './block.json';

export const ListPartnersThemeControls: ThemeControlsType = mergeDeep(
	ListCardsThemeControls,
	{
		// What's displayed
		title: block.title,

		// Unique string/id of the block (= the key used in theme.json)
		slug: block.slug,
	}
);
